<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid >
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12" v-if="!complete">
							<v-toolbar dark color="primary">
								<v-toolbar-title>Forgot Password</v-toolbar-title>
							</v-toolbar>
							<v-card-text>
								<v-text-field prepend-icon="fas fa-user" name="email"
									v-validate="'required|email'" :error-messages="errors.collect('email')" required
									label="Email" type="text" v-model="username"></v-text-field>
								<v-alert :value="serverDown" type="error">
									Server unavailable
								</v-alert>
								<v-alert :value="invalid" type="warning">
									Username not found
								</v-alert>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="reset" :loading="resetting"
									:disabled="resetting || errors.any()">Reset</v-btn>
							</v-card-actions>
						</v-card>
						<v-card class="elevation-12" v-else>
							<v-toolbar dark color="success">
								<v-toolbar-title>Reset Sent</v-toolbar-title>
							</v-toolbar>
							<v-card-text class="py-5">
								Please check your email to complete your password reset.
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import analysisApi from "../analysisApi";

export default {
	data() {
		return {
			username: null,
			resetting: false,
			invalid: false,
			serverDown: false,
			complete: false,
		};
	},
	methods: {
		reset() {
			this.resetting = true;
			this.invalid = false;
			this.serverDown = false;
			analysisApi.forgotPassword(this.username)
				.then(() => {
					this.resetting = false;
					this.complete = true;
				})
				.catch(() => {
					this.resetting = false;
					this.invalid = true;
				});
		},
	},
};
</script>
